import { Form, Select } from "antd";
import { ReactElement, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";

import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";
import "./edit-communication.scss";
import { PhoneInput } from "react-international-phone";
import {
  ADD_TO_BREADCRUMB,
  LOADING,
  REMOVE_FROM_BREADCRUMB,
} from "../../store/actions";
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import instance from "../../store/axios";
import toast from "react-hot-toast";
import ReactCountryFlag from "react-country-flag";
import CollapseComponent from "../../components/collapse.component";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";

const { Option } = Select;

const EditCommunication: React.FC = (): ReactElement => {
  const { accountId, activeKyc } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");
  const [form] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState<any>();
  const [countriesData, setCountriesData] = useState([]);

  useEffect(() => {
    getCountriesData();
    getKycApi();

    dispatch({
      type: ADD_TO_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: `Update communication and address details`,
            type: "text",
          },
        ],
      },
    });

    return () => {
      dispatch({
        type: REMOVE_FROM_BREADCRUMB,
        payload: {
          breadcrumb: [
            {
              text: `Update communication and address details`,
            },
          ],
        },
      });
    };
  }, []);

  const getKycApi = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}?kycId=${activeKyc}`
      );
      setAccountDetails(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/communication-address/${accountId}/${activeKyc}/edit`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  const getCountriesData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/countries?partial=${1}`
      );
      setCountriesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/communication-address/${accountId}/${activeKyc}/edit`
      );
    }
  };

  const onSubmit = async (values: any): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    values.kycId = accountDetails.accountInfo[0]?.id;
    values.residentialFloor = "";
    values.branch = "KW";
    
    if (!values.workCountryId) {
      delete values.workCountryId;
      delete values.workCity;
      delete values.workBuilding;
      delete values.workStreet;
      delete values.workAvenue;
      delete values.workBlock;
      delete values.workPoBox;
      delete values.workPostalCode;
      delete values.workAddressDetails;
    }

    for (const key in values) {
      if (values[key] === null) {
        values[key] = "";
      }
    }

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/communication/update`, values);
      toast.success("Communication & Address updated successfully");
      navigate(
        `/home/business-account/${accountId}/${activeKyc}/details?tab=5${
          isApproveCase ? "&approve=1" : ""
        }`
      );
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/communication-address/${accountId}/${activeKyc}/edit${
          isApproveCase ? "?approve=1" : ""
        }`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  return (
    <div className="edit-communication-container flex flex-col">
      <BreadcrumbComponent />
      <h2 className=" font-semibold text-xl mb-8">Communication & Address</h2>
      {accountDetails?.id && (
        <Form
          className="add-edit-form"
          onFinish={onSubmit}
          initialValues={{
            mobileNumber: accountDetails?.accountInfo[0]?.mobileNumber,
            workNumber: accountDetails?.accountInfo[0]?.workNumber,
            homeNumber: accountDetails?.accountInfo[0]?.homeNumber,
            residentialBuilding:
              accountDetails?.accountInfo[0]?.residentialBuilding,
            residentialStreet:
              accountDetails?.accountInfo[0]?.residentialStreet,
            residentialAvenue:
              accountDetails?.accountInfo[0]?.residentialAvenue,
            residentialBlock: accountDetails?.accountInfo[0]?.residentialBlock,
            residentialCountryId:
              accountDetails?.accountInfo[0]?.residentialCountryId,
            residentialCity: accountDetails?.accountInfo[0]?.residentialCity,
            residentialPoBox: accountDetails?.accountInfo[0]?.residentialPoBox,
            residentialZipCode:
              accountDetails?.accountInfo[0]?.residentialZipCode,
            residentialAddressDetails:
              accountDetails?.accountInfo[0]?.residentialAddressDetails,
            workBuilding: accountDetails?.accountInfo[0]?.workBuilding,
            workStreet: accountDetails?.accountInfo[0]?.workStreet,
            workAvenue: accountDetails?.accountInfo[0]?.workAvenue,
            workBlock: accountDetails?.accountInfo[0]?.workBlock,
            workCity: accountDetails?.accountInfo[0]?.workCity,
            workCountryId: accountDetails?.accountInfo[0]?.workCountryId,
            workPoBox: accountDetails?.accountInfo[0]?.workPoBox,
            workPostalCode: accountDetails?.accountInfo[0]?.workPostalCode,
            workAddressDetails:
              accountDetails?.accountInfo[0]?.workAddressDetails,
          }}
          form={form}
        >
          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className=" text-lg font-semibold">
                  Communication Details
                </h3>
              </div>
            }
          >
            <div className="fields flex justify-space-between wrap">
              <div className="field flex column">
                <Label text="Mobile" />
                <Form.Item
                  name="mobileNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please input your mobile number!",
                    },
                  ]}
                >
                  <div className="phone-input">
                    <PhoneInput
                      placeholder="Enter mobile number"
                      value={accountDetails?.accountInfo[0]?.mobileNumber || ""}
                      defaultCountry="kw"
                      // onChange={() => setValue("")}
                    />
                    <span className="sub-text">
                      Phone number format: countrycode-phone (Example:
                      +965-00000000)
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className="field flex column">
                <Label text="Work Tel." />
                <Form.Item name="workNumber">
                  <div className="phone-input">
                    <PhoneInput
                      placeholder="Enter Work Tel."
                      value={accountDetails?.accountInfo[0]?.workNumber || ""}
                      defaultCountry="kw"
                      // onChange={() => setValue("")}
                    />
                    <span className="sub-text">
                      Phone number format: countrycode-phone (Example:
                      +965-00000000)
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className="field flex column">
                <Label text="Home Tel." />
                <Form.Item name="homeNumber">
                  <div className="phone-input">
                    <PhoneInput
                      placeholder="Enter Home Tel."
                      value={accountDetails?.accountInfo[0]?.homeNumber || ""}
                      defaultCountry="kw"
                      // onChange={() => setValue("")}
                    />
                    <span className="sub-text">
                      Phone number format: countrycode-phone (Example:
                      +965-00000000)
                    </span>
                  </div>
                </Form.Item>
              </div>
            </div>
          </CollapseComponent>
          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className=" text-lg font-semibold">
                  Residential address details
                </h3>
              </div>
            }
          >
            <div className="fields flex justify-space-between wrap">
              <div className="field flex flex-col">
                <Label text="Country" />
                <Form.Item
                  name="residentialCountryId"
                  rules={[
                    {
                      required: true,
                      message: "Please select the Country!",
                    },
                  ]}
                  validateTrigger={["onChange", "onBlur"]}
                >
                  <Select
                    placeholder="Select Country"
                    allowClear
                    showSearch
                    filterOption={(input, option: any) => {
                      return (option?.key.toLowerCase() ?? "").includes(
                        input.toLowerCase()
                      );
                    }}
                  >
                    {countriesData.map((country: any) => (
                      <Option value={country.id} key={country.nameEn}>
                        <div
                          className="flex align-center"
                          style={{ gap: "5px" }}
                        >
                          <ReactCountryFlag
                            style={{
                              fontSize: "24px",
                              marginInlineEnd: "8px",
                            }}
                            countryCode={country?.countryCode}
                            svg
                          />
                          <span>{country.nameEn}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="City" />
                <Form.Item
                  name="residentialCity"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the city!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter city" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Building" />
                <Form.Item
                  name="residentialBuilding"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the Building!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Building" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Street" />
                <Form.Item
                  name="residentialStreet"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the Street!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter Street" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Avenue" />
                <Form.Item name="residentialAvenue">
                  <CustomInput placeholder="Enter Avenue" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Block" />
                <Form.Item
                  name="residentialBlock"
                  validateTrigger={["onChange", "onBlur"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      dependencies: ["residentialCountryId"],
                      validator(_, value) {
                        const countryId = getFieldValue("residentialCountryId");
                        if (countryId === 98 && !value?.trim()) {
                          return Promise.reject(
                            new Error("Please enter the residential block")
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <CustomInput placeholder="Enter Block" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="P.O.Box" />
                <Form.Item name="residentialPoBox">
                  <CustomInput placeholder="Enter input P.O.Boxe" />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Postal Code" />
                <Form.Item name="residentialZipCode">
                  <CustomInput placeholder="Enter input Postal Code" />
                </Form.Item>
              </div>

              <div className="fields flex column">
                <Label text="Additional address details" />
                <Form.Item name="residentialAddressDetails">
                  <TextArea
                    rows={4}
                    placeholder="Enter Additional address details"
                  />
                </Form.Item>
              </div>
            </div>
          </CollapseComponent>
          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className=" text-lg font-semibold">Work address details</h3>
              </div>
            }
          >
            <div className="flex flex-col">
              <div className="fields flex justify-space-between wrap">
                <div className="field flex column">
                  <Label text="Country" />
                  <Form.Item
                    name="workCountryId"
                    validateTrigger={["onChange", "onBlur"]}
                  >
                    <Select
                      placeholder="Select Country"
                      showSearch
                      filterOption={(input, option: any) => {
                        return (option?.key.toLowerCase() ?? "").includes(
                          input.toLowerCase()
                        );
                      }}
                    >
                      {countriesData.map((country: any) => (
                        <Option value={country.id} key={country.nameEn}>
                          <div
                            className="flex align-center"
                            style={{ gap: "5px" }}
                          >
                            <ReactCountryFlag
                              style={{
                                fontSize: "24px",
                                marginInlineEnd: "8px",
                              }}
                              countryCode={country?.countryCode}
                              svg
                            />
                            <span>{country.nameEn}</span>
                          </div>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="field flex flex-col">
                  <Label text="City" />
                  <Form.Item
                    name="workCity"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const countryId = getFieldValue("workCountryId");
                          if (countryId && !value?.trim()) {
                            return Promise.reject(
                              new Error("Please enter the city")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <CustomInput placeholder="Enter city" />
                  </Form.Item>
                </div>
                <div className="field flex flex-col">
                  <Label text="Building" />
                  <Form.Item
                    name="workBuilding"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const countryId = getFieldValue("workCountryId");
                          if (countryId && !value?.trim()) {
                            return Promise.reject(
                              new Error("Please enter the building")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <CustomInput placeholder="Enter Building" />
                  </Form.Item>
                </div>

                <div className="field flex flex-col">
                  <Label text="Street" />
                  <Form.Item
                    name="workStreet"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const countryId = getFieldValue("workCountryId");
                          if (countryId && !value?.trim()) {
                            return Promise.reject(
                              new Error("Please enter the street")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <CustomInput placeholder="Enter Street" />
                  </Form.Item>
                </div>

                <div className="field flex flex-col">
                  <Label text="Avenue" />
                  <Form.Item name="workAvenue">
                    <CustomInput placeholder="Enter Avenue" />
                  </Form.Item>
                </div>

                <div className="field flex column">
                  <Label text="Block" />
                  <Form.Item
                    name="workBlock"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const countryId = getFieldValue("workCountryId");
                          if (countryId === 98 && !value?.trim()) {
                            return Promise.reject(
                              new Error("Please enter the block")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <CustomInput placeholder="Enter Block" />
                  </Form.Item>
                </div>

                <div className="field flex column">
                  <Label text="P.O.Box" />
                  <Form.Item name="workPoBox">
                    <CustomInput placeholder="Enter input P.O.Boxe" />
                  </Form.Item>
                </div>

                <div className="field flex column">
                  <Label text="Postal Code" />
                  <Form.Item name="workPostalCode">
                    <CustomInput placeholder="Enter input Postal Code" />
                  </Form.Item>
                </div>

                <div className="fields flex column">
                  <Label text="Additional address details " />
                  <Form.Item name="workAddressDetails">
                    <TextArea
                      rows={4}
                      placeholder="Enter Additional address details "
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </CollapseComponent>
          <div className="flex w-full flex-wrap items-center justify-end mt-7 pt-5">
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                onClick={() =>
                  navigate(
                    `/home/business-account/${accountId}/${activeKyc}/details?tab=5${
                      isApproveCase ? "&approve=1" : ""
                    }`
                  )
                }
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
              >
                Cancel
              </button>
              <button className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white">
                Save
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default EditCommunication;
